module.exports = __webpack_public_path__ + "img/more.21b9233c.png";